import { lazy } from 'react';

import { retry } from 'src/utils/routing';

export default {
    name: 'not_found',
    path: '/not-found',
    component: () => lazy(() => retry(() => import('./index')))
};
